import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { clearImpersonation } from '@/features/impersonation';
import { ApiError } from '@/shared/api/ApiError';
import { postLogout } from '@/shared/api/auth';
import { getRoutePath } from '@/shared/utils/routes';

export const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const onLogout = () => {
    // Drop any active impersonation session on logout. Otherwise the partner's
    // sessionStorage would still hold a client JWT that the request interceptor
    // would re-attach as Bearer on the next login, silently re-entering the
    // client cabinet.
    clearImpersonation();
    queryClient.clear();
    navigate(getRoutePath('AUTH', 'LOGIN'));
  };

  const logoutMutation = useMutation({
    mutationFn: postLogout,
    onSuccess: onLogout,
    onError: (error) => {
      if (error instanceof ApiError && error.status === 401) {
        onLogout();
      }
    },
  });

  const logout = () => {
    logoutMutation.mutate(undefined);
  };

  return { logout, onLogout };
};
